import React from 'react';
export function CTASection() {
  return <section className="py-10 px-5 bg-cta-radial text-center" data-id="element-47">
      <h2 className="font-playfair text-[clamp(22px,3.5vw,36px)] text-blanco mb-3 max-w-[750px] mx-auto" data-id="element-48">
        El Momento de Dejar de Ver y Empezar a{' '}
        <em className="text-dorado not-italic" data-id="element-49">Brillar</em> es Ahora
      </h2>
      <p className="text-[16px] text-oro-rosa-claro mb-6 italic" data-id="element-50">
        Cada día que esperás es un pedido que otra emprendedora está cerrando.
      </p>
      <a href="https://pagos.indigo33.shop/cart/44022797729880:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-cta text-negro py-4 px-10 rounded-[60px] text-[clamp(16px,2.2vw,20px)] font-black no-underline tracking-[1px] transition-all duration-400 shadow-[0_15px_40px_rgba(212,175,55,0.4)] animate-pulse-cta uppercase cursor-pointer border-none hover:-translate-y-[3px] hover:scale-[1.03]" data-id="element-51">
        💎 SÍ, QUIERO MI EFECTO DIAMANTE AHORA →
      </a>
      <div className="mt-3 text-[13px] text-[#888] flex justify-center items-center gap-4 flex-wrap" data-id="element-52">
        <span className="flex items-center gap-1" data-id="element-53">🔒 Pago 100% Seguro</span>
        <span className="flex items-center gap-1" data-id="element-54">⚡ Acceso Inmediato</span>
        <span className="flex items-center gap-1" data-id="element-55">🛡️ Garantía 30 Días</span>
        <span className="flex items-center gap-1" data-id="element-56">💳 6 Cuotas Sin Interés</span>
        <span className="flex items-center gap-1" data-id="element-57">📧 Soporte Incluido</span>
      </div>
    </section>;
}